import { render, staticRenderFns } from "./buyer.vue?vue&type=template&id=55718df1&lang=html&"
import script from "./buyer.vue?vue&type=script&lang=js&"
export * from "./buyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports